import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, videos, conselho_fiscal } from '../../../settings';
import { DelayLink, CardSliderFotos } from '../../../components';

import './ConselhoFiscal.scss';

class ConselhoFiscal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };

    this.conselho_fiscal = conselho_fiscal.pessoas;
    this.images = images;
    this.videos = videos;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Governança Corporativa - {this.texts.title}</title>
        </Helmet>

        <div className="conselho-fiscal-home page-gradient page-gradient--blue bg-gray" ref="conselho-fiscal-home">
          <section className="governanca-home-area governanca-header page-gradient__header">
            <div className="container tela-max">
              <div className="page-header">
                <h1 className="page-header__title tituto-top">
                  <img src={this.images.conselho_fiscal.icon_titulo_top} />
                  Conselho Fiscal
                </h1>
              </div>
            </div>
            <div className="container tela-max-top">
              <div className="row flex">
                <div className="col-7">
                  <Fade bottom>
                    <div className="page-header pading-medio">
                      
                      <p className="page-header__description gri_text_top_desc">
                      É formado por três representantes dos associados, 
                      que são eleitos junto com a Diretoria pela Assembleia Geral.
                      <br/><br/>
                      Eles devem examinar as contas e demonstrações financeiras da Associação, 
                      além de contratar uma auditoria externa independente para dar um parecer 
                      sobre o material. Têm uma reunião presencial no ano, mas podem ser 
                      convocados para encontros extraordinários.
                      </p>
                     {/*  <p className="page-header__description gri_text_top_desc">
                      Eles devem examinar as contas e demonstrações financeiras da Associação, 
                      além de contratar uma auditoria externa independente para dar um parecer 
                      sobre o material. Têm uma reunião presencial no ano, mas podem ser 
                      convocados para encontros extraordinários.
                      </p> */}
                    </div>
                  </Fade>
                </div>
                <div className="anime-top col-5">
                  <div className="row">
                    <Fade>
                      <div className="col-12 pessoas-animadas">
                        <img src={this.images.conselho_fiscal.pessoa_top} className="pessoa_top_fiscal"/>
                        <img src={this.images.conselho_fiscal.pessoa_top_grafico} className="pessoa_top_grafico_fiscal"/>
                        <img src={this.images.conselho_fiscal.pessoa_top_olhos} className="pessoa_top_olhos_fiscal"/>
                        <img src={this.images.conselho_fiscal.pessoa_top_bolha1} className="pessoa_top_bolha1_fiscal"/>
                        <img src={this.images.conselho_fiscal.pessoa_top_bolha2} className="pessoa_top_bolha2_fiscal"/>
                        <img src={this.images.conselho_fiscal.pessoa_top_bolha3} className="pessoa_top_bolha3_fiscal"/>
                        <img src={this.images.conselho_fiscal.pessoa_top_mobile} className="pessoa_top_mobile_fiscal"/>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="governanca-body governanca-body--card page--blue">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <h2 className="title-conselho">
                        Conselho Fiscal em dezembro de 2020
                        {/* Conheça o <b>conselho Fiscal</b> em exercício no final de 2020: */}
                      </h2>

                      <CardSliderFotos
                        items={this.conselho_fiscal}
                        url={this.images.conselho_fiscal.path_url}
                        color={'blue'}
                      />
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="conselho-fiscal-footer-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-12 col--text">
                            <h4 className="footer-governanca-2020">Entenda como é formado o nosso Conselho de Ética</h4>
                            <DelayLink
                              to="/governanca-corporativa/conselho-de-etica"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          <div className="col col-3 col--image">
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { ConselhoFiscal };
